import type { RouteObject } from "react-router";

import { APP_ROUTES } from "./router-app-routes";
import { AUTH_ROUTES } from "./router-auth-routes";
import { RouterErrorBoundary } from "./router-error-boundary";
import { STATIC_ROUTES } from "./router-static-routes";

export const ROUTER_ROUTES: RouteObject[] = [
  {
    errorElement: <RouterErrorBoundary />,
    children: [
      // Keep order to make sure auth & static routes are working well
      ...AUTH_ROUTES,
      ...STATIC_ROUTES,
      ...APP_ROUTES,
    ],
  },
];
